import r, { useRef as _, useEffect as N } from "react";
import { createPortal as T } from "react-dom";
import E from "classnames";
import { CSSTransition as A } from "react-transition-group";
import { OpacityAnimation as F } from "../../../animations/OpacityAnimation/OpacityAnimation.js";
import a from "./modal.module.scss.js";
import o from "./animations/modal-transition.module.scss.js";
const y = "#FFF", v = "#242323";
function K({
  children: k,
  onClose: t,
  onOpen: c,
  design: e = {
    textColor: y,
    backgroundColor: v
  },
  title: n,
  show: l,
  showCloseBtn: s = !0,
  overflowContent: p = !1,
  dismissOnBackdrop: x = !0,
  dismissOnEscape: i = !0
}) {
  const b = _(null), d = _(null), u = (m) => {
    (m.charCode || m.keyCode) === 27 && i && (t == null || t());
  };
  N(() => (document.body.addEventListener("keydown", u), function() {
    document.body.removeEventListener("keydown", u);
  }), [i, t]);
  const f = /* @__PURE__ */ r.createElement("div", { ref: b, "data-testid": "modal", className: a.modal }, /* @__PURE__ */ r.createElement(
    F,
    {
      in: l
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        onClick: () => {
          x && (t == null || t());
        },
        className: a.modal__backdrop
      }
    )
  ), /* @__PURE__ */ r.createElement(
    A,
    {
      in: l,
      nodeRef: d,
      timeout: 300,
      classNames: {
        enter: o.modalTransitionEnter,
        enterActive: o.modalTransitionEnterActive,
        exit: o.modalTransitionExit,
        exitActive: o.modalTransitionExitActive
      },
      onEnter: () => c == null ? void 0 : c(),
      unmountOnExit: !0
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: a.modal__content,
        ref: d,
        style: {
          backgroundColor: (e == null ? void 0 : e.backgroundColor) ?? v,
          color: (e == null ? void 0 : e.textColor) ?? y,
          fontFamily: e == null ? void 0 : e.fontFamily
        }
      },
      /* @__PURE__ */ r.createElement(
        "div",
        {
          className: E({
            [a.modal__content__header]: !0,
            [a.modal__content__header__filled]: n && n.length > 0
          })
        },
        /* @__PURE__ */ r.createElement("span", null, n || ""),
        s && /* @__PURE__ */ r.createElement(
          "i",
          {
            className: "lni lni-close",
            onClick: () => t == null ? void 0 : t()
          }
        )
      ),
      /* @__PURE__ */ r.createElement(
        "div",
        {
          className: E({
            [a.modal__content__body]: !0,
            [a.overflowContent]: p
          })
        },
        k
      )
    )
  ));
  return typeof document > "u" ? f : T(f, document.body);
}
export {
  K as Modal
};
//# sourceMappingURL=Modal.js.map
